import { render, staticRenderFns } from "./LaxyNglViewer.vue?vue&type=template&id=be0f55be"
import script from "./LaxyNglViewer.vue?vue&type=script&lang=ts"
export * from "./LaxyNglViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports